import * as React from 'react';
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@material-ui/core/styles/withStyles';
import {Switch, Route} from 'react-router-dom';
import {Theme} from '@material-ui/core/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';
import AcknowledgeDocumentSwitch from '~common/components/acknowledge-document-switch';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  match: any;
}

type State = {};

class Invite extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {};
  }

  componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>
  ) {}

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {match} = this.props;

    return (
      <div className={classes.container}>
        <AppView history={this.props.history}>
          <FormBasedEditor
            noDefinitionFoundMessage={(((window as any).App || {browserEnvironment:{}}).browserEnvironment || {}).BROWSER_EXPIRED_REGISTER_LINK_MESSAGE}
            history={this.props.history}
            match={this.props.match}
            hideCancelButton={true}
            dataUrl="/api/portal-users/register"
            formSelector={{
              form: 'registerPortalUser',
              modules: 'users',
              userType: 'Any'
            }}
            errorFormSelector={{
              formType: 'userRegisterTokenExpire',
              modules: 'users',
              userType: 'Any'
            }}
            successMessage="Your account has been created.  You will now be forwarded to the login page."
            // If provided, redirectUrl where the user will be sent upon success
            redirectUrl="/login"
            submitButtonText="Register"
            customRenderers={{
              "AcknowledgeDocumentSwitch": AcknowledgeDocumentSwitch 
            }}></FormBasedEditor>
        </AppView>
      </div>
    );
  }
}

export default withStyles(styles)(Invite);
